import React, { useEffect, useState, useRef } from 'react';
import Button from '@material-ui/core/Button';
import {
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Label,
  Input as IMP,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter
} from 'reactstrap';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Device } from '@twilio/voice-sdk';
import { useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import { savenotes } from '../../Redux/Actions/USER/user';
import { gettoken } from '../../Redux/Actions/Twilio';
import CallIcon from '@material-ui/icons/Call';
import CallEndIcon from '@material-ui/icons/CallEnd';
import NewDialer from '../../view/pages/Home/newdialer';
import UserForm from '../../view/pages/Home/Form';
import AddProspect1 from '../../view/pages/Prospects/addProspect1';
import Popup from 'reactjs-popup';
import { initializeDevice } from './twilioDevice';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhoneAlt } from '@fortawesome/free-solid-svg-icons';
import ChatAssistantBox from './ChatAssistantBox';

const axios = require('axios');
const AlertDialog = ({ dialog, setDialogs, setpopDialogs, savenotes, Token, gettoken }) => {
  console.log('inside dial modal top');
  const [showChat, setShowChat] = useState(false);
  const [callEnded, setCallEnded] = useState(false);

  const [open, setOpen] = React.useState(false);
  const [openI, setOpenI] = React.useState(false);
  const [notedial, setnotedial] = React.useState(false);
  const [connection, setConnection] = React.useState('');
  const [note, setnotes] = React.useState('');
  const [details, setdetails] = React.useState(null);
  const [details1, setdetails1] = React.useState(null);
  const [cmpname, setcmpname] = React.useState(null);
  const [cmpname1, setcmpname1] = React.useState(null);
  const [device, setDevice] = React.useState();
  const [isOpenDial, setclosedialer] = React.useState(false);
  const [dil, setdil] = React.useState(true);
  const [allowdigit, setallowdigit] = React.useState(false);
  const [callconnect, setcallconnect] = React.useState(false);
  const [notetoggle, setnotetoggle] = React.useState(false);
  const [mic, setmicrophone] = React.useState(false);
  const [formshow, setshowform] = React.useState(false);
  const [showprospet, setshowprospet] = React.useState(false);
  const [timer, setTimer] = React.useState(false);
  const [num, setnum] = React.useState('');
  const [seconds, setSeconds] = React.useState(0);
  const [handle, setHandle] = React.useState(null);
  const [incomingCalls, setIncomingCalls] = React.useState([]);
  const [activeCall, setActiveCall] = React.useState(null);
  const [selectedCall, setSelectedCall] = useState(null);
  const selectedCallRef = useRef(null);
  const activeCallRef = useRef(null);
  const [showCallOptions, setShowCallOptions] = useState(false);
  const [callListOpen, setCallListOpen] = useState(true);
  const history = useHistory();
  const handleClose = () => {
    connection.reject();
    setOpen(false);
    setpopDialogs(false);
    setnotedial(true);
  };
  const handelOpen = () => {
    console.log('===============inside handelOpen===============');

    setCallListOpen(true);
  
  };
  const formtoogleToggle = () => {
    setshowform(!formshow);
  };
 
  const closedialer = () => {
    setclosedialer(!isOpenDial);
  };
  const changestatus = () => {
    setcallconnect(false);
  };
  const NoteToggle = () => {
    setnotetoggle(!notetoggle);
    setnotedial(true);

    console.log('Note Toggle Called');
  };
  console.log('inside dial modal');
  
  const notedialog = () => {
    setnotedial(false);
  };
  const handleEsc = () => {
    setOpen(false);
    setpopDialogs(true);
  };

  const stateChanger = title => {
    setclosedialer(title);
  };
  const stateChanger1 = title => {
    setshowprospet(title);
  };
  useEffect(() => {
    if (dialog === true) {
      setOpen(true);
      setDialogs(false);
    }
  }, [dialog]);
  useEffect(() => {
    return () => {
      if (handle) {
        clearInterval(handle);
      }
    };
  }, [handle]);

  useEffect(() => {
    if (Token === '') {
      gettoken();
    } else {
      fetchdata();
    }
    if (timer) {
      const interval = setInterval(() => {
        setSeconds(seconds => seconds + 1);
      }, 1000);
      setHandle(interval);
    }
    async function fetchdata() {
    
      const device1 = await initializeDevice(Token);

    
      console.log('device1', device1);
      try {
        device1.register();
      } catch (errorReg) {
        console.log('Handle Register', errorReg);
      }
      device1.addListener('registered', device => {
        console.log('The device is ready to receive incoming calls.');
      });
      device1.on('incoming', handleIncomingCall);
    
      device1.on('destroyed', function(connection) {
        console.log('DialModel device >> destroyed');
    
      });
      setDevice(device1);
    }
  }, [Token, gettoken]);

  const handleIncomingCall = call => {
    const callId = call.parameters.CallSid;
    console.log('callId', callId);
    setIncomingCalls(prevCalls => {
      const isDuplicate = prevCalls.some(c => c.id === callId);
      if (!isDuplicate) {
        const newCalls = [...prevCalls, { call, id: callId }];
        // return [...prevCalls, { call, id: callId }];
        if (newCalls.length === 1) {
          setSelectedCall({ call, id: callId });
          selectedCallRef.current = { call, id: callId };
          setShowCallOptions(true);

          let url = process.env.REACT_APP_PORT + `/api/me/getdetails`;
          var data1 = call.parameters.From;

          var config = {
            method: 'post',
            url: url,
            headers: {
              'x-auth-token': localStorage.getItem('token')
            },
            data: { option: data1 }
          };

          axios(config)
            .then(function(response) {
              console.log(JSON.stringify(response.data.data));
              setdetails(response.data.data[0]);
              setcmpname(response.data.data[1]);
            })
            .catch(function(error) {
              console.log(error);
            });
        }

        return newCalls;
      }
      return prevCalls;
    });
    call.on('disconnect', () => {
      console.log('Disconnect callId', callId);
      setIncomingCalls(prevCalls => prevCalls.filter(c => c.id !== callId));
      setActiveCall(null);
      activeCallRef.current = null;
      setallowdigit(false);
      setdil(true);
      setOpenI(false);
      setclosedialer(false);
      setshowprospet(false);
      setSeconds(0);
      if (handle) {
        clearInterval(handle);
      }
    });
    call.on('cancel', () => {
      if (activeCallRef.current?.id !== callId) {
        console.log('active', activeCall, activeCallRef.current, 'cancelCall', callId);
        console.log('Cancel Call', callId);

        setIncomingCalls(prevCalls => prevCalls.filter(c => c.id !== callId));

        console.log('selectedCall', selectedCallRef.current);

        if (selectedCallRef.current?.id === callId) {
          setSelectedCall(null);
          setShowCallOptions(false);
          console.log('inside close dialog');
        }
      }
    });
    call.on('reject', () => {
      console.log('Reject Call', callId);
      setIncomingCalls(prevCalls => prevCalls.filter(c => c.id !== callId));
    });
  };

  const removeCall = callId => {
  };

  const handleSelectCall = call => {
    console.log('activeCall', activeCall);
    if (!activeCall || activeCall.id !== call.id) {
      setSelectedCall(call);
      selectedCallRef.current = call;
      setCallListOpen(false);
      setShowCallOptions(true);
      let url = process.env.REACT_APP_PORT + `/api/me/getdetails`;
      var data1 = call.call.parameters.From;

      var config = {
        method: 'post',
        url: url,
        headers: {
          'x-auth-token': localStorage.getItem('token')
        },
        data: { option: data1 }
      };

      axios(config)
        .then(function(response) {
          console.log(JSON.stringify(response.data.data));
          setdetails(response.data.data[0]);
          setcmpname(response.data.data[1]);
        })
        .catch(function(error) {
          console.log(error);
        });
    } else {
      setclosedialer(true);
      setCallListOpen(false);
    }
  };

  const handleAccept = async () => {
    if (selectedCall?.call) {
       
      selectedCall.call.accept();
      await setActiveCall(selectedCall);

setcallconnect(true);  // 🔁 Ensure this is also triggered
setShowChat(true);     // ✅ Show Chat when call connects
setCallEnded(false);   // ✅ Reset end flag


      setIncomingCalls(prevCalls =>
        prevCalls.map(call => (call.id === selectedCall.id ? { ...call, isActive: true } : call))
      );

      activeCallRef.current = selectedCall;
      console.log('selectedCall', selectedCall.call);
      await setConnection(selectedCall.call);
      setShowCallOptions(false);

      setOpen(false);
      setOpenI(true);
      setpopDialogs(false);
      setdetails(details);
      setcmpname(cmpname);
      setdil(false);
      setclosedialer(true);
      setTimer(true);
      let url = process.env.REACT_APP_PORT + `/api/me/getdetails`;
      var data1 = selectedCall.call.parameters.From;
      setnum(data1);
      var config = {
        method: 'post',
        url: url,
        headers: {
          'x-auth-token': localStorage.getItem('token')
        },
        data: { option: data1 }
      };

      axios(config)
        .then(function(response) {
          console.log(JSON.stringify(response.data.data));
          setdetails1(response.data.data[0]);
          setcmpname1(response.data.data[1]);
        })
        .catch(function(error) {
          console.log(error);
        });

     

    }
  };

  const handleReject = () => {
    if (selectedCall?.call) {
      selectedCall.call.reject();
      setShowCallOptions(false);
      
    }
  };

  const handleIgnore = () => {
    if (selectedCall?.call) {
      selectedCall.call.ignore();
      console.log('selectedCall', selectedCall);
      setIncomingCalls(prevCalls => prevCalls.filter(c => c.id !== selectedCall.id));
      setShowCallOptions(false);
      // setpopDialogs(true)
    }
  };

  const disconnect = () => {
    if (activeCall?.call) {
      activeCall.call.disconnect();
      setnotedial(true);
      setCallEnded(true); // <- Set flag to show close (X)

      console.log('DialModel disconnect>> connection >>', activeCall.call);
    }
  };

  return (
    <>
    <div>
      <Dialog open={incomingCalls.length > 0 && callListOpen} onClose={() => setCallListOpen(false)}>
        <Card>
          <CardHeader>
            <CardTitle style={{ fontSize: '24px', color: '#b4d9e5', textAlign: 'center' }}>
              Active Call Line-Up
            </CardTitle>
          </CardHeader>
          <CardBody>
            {incomingCalls.map(c => (
              <Button
                key={c.id}
                style={{
                  display: 'block',
                  marginBottom: '10px',
                  borderRadius: '15px',
                  backgroundColor: c.isActive ? '#4CAF50' : '#2196F3', // Active call has green background
                  color: 'white',
                  fontWeight: 'bold',
                  textTransform: 'none',
                  padding: '10px',
                  width: '100%',
                  fontSize: '16px',
                  boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)'
                }}
                variant="contained"
                onClick={() => handleSelectCall(c)}
              >
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <i
                    className={`fas fa-phone-alt ${c.isActive ? 'fa-spin' : ''}`} // Add a spinning animation for active call
                    style={{ marginRight: '10px', color: 'white' }}
                  />
                  Call from: {c.call.parameters.From || 'Unknown'}
                  {c.isActive && (
                    <span
                      style={{
                        marginLeft: '5px',
                        padding: '5px 10px',
                        backgroundColor: '#ff6347',
                        borderRadius: '20px',
                        color: 'white',
                        fontSize: '14px',
                        display: 'flex',
                        alignItems: 'center'
                      }}
                    >
                      <i
                        className="fas fa-microphone"
                        style={{ marginRight: '5px', color: 'white', fontSize: '16px' }}
                      />
                      Speaking
                    </span>
                  )}
                </div>
              </Button>
            ))}
          </CardBody>
        </Card>
      </Dialog>

      <Dialog open={showCallOptions} onClose={() => setShowCallOptions(false)}>
        <Card>
          <CardHeader>
            <CardTitle>
              <div className="ml-6">
                <i className="fas fa-user-circle" style={{ color: '#b4d9e5', fontSize: '100px' }} />
              </div>
              <p style={{ color: '#b4d9e5', marginLeft: '21px', marginTop: '10px' }}>
                From: {selectedCall?.call.parameters.From || '+17542002251'}
              </p>
              <p className="ml-6" style={{ color: '#b4d9e5' }}>
                Incoming Call
              </p>
            </CardTitle>
          </CardHeader>
          <DialogActions>
            <CardBody>
              <Row xs={12}>
                <Col md={6}>
                  <Button onClick={handleAccept} style={{ borderRadius: '30px' }} variant="contained" color="primary">
                    <CallIcon />
                    &nbsp;Accept
                  </Button>
                </Col>
                <Col md={6}>
                  <Button
                    onClick={handleReject}
                    style={{ borderRadius: '30px', whiteSpace: 'nowrap' }}
                    variant="contained"
                    color="secondary"
                  >
                    <i className="fas fa-phone-slash" />
                    &nbsp;Reject
                  </Button>
                </Col>
              </Row>
              <Row className="mt-4">
                <Col md={12}>
                  <center>
                    <Button
                      onClick={handleIgnore}
                      style={{ borderRadius: '30px', whiteSpace: 'nowrap' }}
                      variant="contained"
                      color="red"
                    >
                      <CallEndIcon />
                      &nbsp;Ignore
                    </Button>
                  </center>
                </Col>
              </Row>
            </CardBody>
          </DialogActions>
          <center>
            {details != null && details != 'Not Found' && (
              <p>
                <strong>Prospect Info:</strong>
                <br />
                <strong>Name:</strong> {details != null && details.hasOwnProperty('first_name') && details.first_name}{' '}
                {details != null && details.hasOwnProperty('last_name') && details.last_name}
                <br />
                <strong>Campaign Name:</strong> {cmpname != null && cmpname} <br />
                <strong>Address: </strong> {details != null && details.hasOwnProperty('address') && details.address}{' '}
                {details != null && details.hasOwnProperty('street') && details.street}{' '}
                {details != null && details.hasOwnProperty('city') && details.city}{' '}
                {details != null && details.hasOwnProperty('state') && details.state}
                <br />
                <strong>Email:</strong> {details != null && details.hasOwnProperty('email') && details.email}
              </p>
            )}
          </center>
        </Card>
      </Dialog>

      <Dialog
        open={notedial}
        onClose={notedialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <Card className="pl-1">
          <DialogActions>
            <CardBody className="p-0">
              <Row>
                <Col xs="12">
                  <DialogTitle className="p-0" id="alert-dialog-title">
                    Note{' '}
                  </DialogTitle>
                  <DialogContent className="p-0 mt-1">
                    <DialogContentText id="alert-dialog-description">
                      From {connection != '' ? connection.parameters.From : ''}
                    </DialogContentText>
                  </DialogContent>
                </Col>
              </Row>
              <Row>
                <Col md="8">
                  <IMP type="textarea" onChange={e => setnotes(e.target.value)} placeholder="add note" />
                </Col>
                <Col md="4">
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => {
                      console.log('saving notes', connection.parameters.From, connection.parameters.CallSid);
                      savenotes(note, connection.parameters.From, connection.parameters.CallSid);
                      setnotedial(false);
                    }}
                  >
                    Submit
                  </Button>
                </Col>
              </Row>
            </CardBody>
          </DialogActions>
        </Card>
      </Dialog>

      <Popup
        modal
        open={isOpenDial}
        closeOnDocumentClick={true}
        closeOnEscape={true}
        onClose={() => {
          setclosedialer(false); // Ensure this function closes the Popup
        }}
      >
        {close => (
          <>
            <Card>
              <CardHeader>
                {dil ? (
                  <span class="pull-right clickable close-icon" data-effect="fadeOut">
                    <i onClick={closedialer} class="fa fa-times" />
                  </span>
                ) : null}
              </CardHeader>
              <CardBody>
                {console.log(formshow, dil, isOpenDial)}
                {dil && isOpenDial ? (
                  <UserForm toogle={closedialer} show={true} changeStatus={changestatus} />
                ) : (
                  <>
                    <center className="pt-2">
                      <NewDialer
                        disconnect={disconnect}
                        savenotes={NoteToggle}
                        setmicrophone={setmicrophone}
                        mic={mic}
                        connection={connection}
                      />
                      <center className="pt-2">
                        <Button
                          onClick={() => {
                            setshowform(true);
                            setclosedialer(false);
                          }}
                          size="small"
                          color="primary"
                          variant="contained"
                        >
                          Form
                        </Button>
                        {details1 != null && details1 == 'Not Found' && (
                          <Button
                            onClick={() => {
                              setshowprospet(true);
                              setclosedialer(false);
                            }}
                            size="small"
                            color="primary"
                            variant="contained"
                            className="mx-1"
                          >
                            Add Prospect
                          </Button>
                        )}
                      </center>
                      {console.log('details', details)}
                      {details1 != null && details1 != 'Not Found' && (
                        <p>
                          <strong>Prospect Info:</strong>
                          <br />
                          <strong>Name:</strong>{' '}
                          {details1 != null && details1.hasOwnProperty('first_name') && details1.first_name}{' '}
                          {details1 != null && details1.hasOwnProperty('last_name') && details1.last_name}
                          <br />
                          <strong>Campaign Name:</strong> {cmpname1 != null && cmpname1} <br />
                          <strong>Address: </strong>{' '}
                          {details1 != null && details1.hasOwnProperty('address') && details1.address}{' '}
                          {details1 != null && details1.hasOwnProperty('street') && details1.street}{' '}
                          {details1 != null && details.hasOwnProperty('city') && details1.city}{' '}
                          {details1 != null && details.hasOwnProperty('state') && details1.state}
                          <br />
                          <strong>Email:</strong>{' '}
                          {details1 != null && details.hasOwnProperty('email') && details1.email}
                        </p>
                      )}
                    </center>
                  </>
                )}
              </CardBody>
            
            </Card>
          </>
        )}
      </Popup>

      {incomingCalls.length > 0 ? (
        <Button
        
          style={{
            backgroundColor: '#0bf957',
            position: 'fixed',
            top: '15vh',
            right: '8vw',
            zIndex: 1000,
            borderRadius: '50%', // Ensures it stays circular
            width: '4.25vw', // Reduced size to 30% of previous size
            height: '4.25vw', // Same as width to maintain circle shape
            padding: '0', // Remove padding to maintain circular size
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: '0px 0px 12px 4px rgba(0,255,0,0.5)',
            transition: 'transform 0.2s ease-in-out',
          }}

         onClick={() => {//New After chatbot
  handelOpen();
  // if (callconnect) {
  //   setShowChat(prev => !prev);
  // }
}}
          
       // onClick={handelOpen}   //  OLD before chatbot
        >
          <FontAwesomeIcon icon={faPhoneAlt} color="white" size="lg" />

        </Button>
      ) : null}
      {formshow ? (
        <Modal size="lg" backdrop="static" isOpen={formshow} toggle={formtoogleToggle} style={{ width: '30%' }}>
          <ModalHeader toggle={formtoogleToggle}>
            <Button
              onClick={() => {
                setshowform(false);
                setclosedialer(true);
              }}
              size="small"
              color="primary"
              variant="contained"
            >
              {' '}
              <i className="fas fa-long-arrow-alt-left my-2" />
              &nbsp;&nbsp; Back to Dialer
            </Button>
          </ModalHeader>
          <ModalBody style={{ backgroundColor: '#f9fafd', height: '600px', overflow: 'auto' }}>
            <UserForm changeStatus={changestatus} to={num} />
          </ModalBody>
        </Modal>
      ) : null}
      {details != null && details == 'Not Found' && showprospet && (
        <div style={{ position: 'fixed', top: '20vh', right: '25vw', zIndex: 1 }}>
          <AddProspect1 stateChanger={stateChanger} stateChanger1={stateChanger1} />
        </div>
      )}
    

    </div>
      <ChatAssistantBox
  visible={showChat} // for production
  callActive={callconnect} // for production
  callEnded={callEnded}  // for production
  // visible={true} // for testing on local
  // callActive={true} // for testing on local
  from={connection?.parameters?.From}
  to={connection?.parameters?.To}
  sessionId={connection?.parameters?.CallSid} //for production
  // sessionId={"testingSessionUsingID-1"} //For testing on local
  onClose={() => setShowChat(false)}
/>
</>
  );
};
const mapStateToProps = state => ({
  Token: state.Twilio.token
});
export default connect(
  mapStateToProps,
  { savenotes, gettoken }
)(AlertDialog);
